module.exports = __webpack_public_path__ + "static/media/portfolio-image.971e0c61.png";